/* Toast examples
import {toast} from 'vue3-toastify'

Success
toast.success(useFormatToastNotificationContent('Hooray', 'All the changes saved'));

Error
toast.error(useFormatToastNotificationContent('Ooops!', 'It seems that not all cells in the table are filled'));
 */

export function useFormatToastNotificationContent(title, subtitle = '') {
    if(subtitle.length !== 0) {
        return `${title}<span class="subtitle">${subtitle}</span>`
    }
    return title;
}